import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  Stack,
  Chip,
  TextField,
  Paper,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import DepartmentService from '../../services/department.service';
import DataTable from '../../components/common/DataTable';

const DepartmentList: React.FC = () => {
  const navigate = useNavigate();
  const [departments, setDepartments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      setLoading(true);
      const response = await DepartmentService.getDepartments({
        'pagination[pageSize]': 100,
      });
      setDepartments(response.data?.data || []);
    } catch (error) {
      console.error('Error fetching departments:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: number) => {
    if (window.confirm('Delete this department?')) {
      try {
        await DepartmentService.deleteDepartment(id);
        fetchDepartments();
      } catch (error) {
        console.error('Error deleting department:', error);
      }
    }
  };

  const filteredDepartments = departments.filter(
    (dept) =>
      dept.attributes?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      dept.attributes?.code?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const columns = [
    { id: 'code', label: 'Code' },
    { id: 'name', label: 'Name' },
    { id: 'description', label: 'Description', format: (value: string) => value || '-' },
    { id: 'location', label: 'Location', format: (value: string) => value || '-' },
    { id: 'email', label: 'Email', format: (value: string) => value || '-' },
    {
      id: 'isActive',
      label: 'Status',
      format: (value: boolean) => (
        <Chip label={value ? 'Active' : 'Inactive'} size="small" color={value ? 'success' : 'default'} />
      ),
    },
  ];

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">Departments</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/departments/create')}
        >
          Add Department
        </Button>
      </Stack>

      <Paper sx={{ p: 2, mb: 3 }}>
        <TextField
          fullWidth
          label="Search departments..."
          variant="outlined"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Paper>

      <DataTable
        columns={columns}
        data={filteredDepartments}
        loading={loading}
        onView={(id) => navigate(`/departments/${id}`)}
        onEdit={(id) => navigate(`/departments/${id}/edit`)}
        onDelete={handleDelete}
      />
    </Box>
  );
};

export default DepartmentList;

